module.exports = __webpack_public_path__ + "static/media/hwexe_animals_4.d93297f4.mp3";